/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* No custom scroll behavior for the header — Prestige's native transparent
   header style-swap (transparent at top → solid past 10px scroll) handles
   the entire Schumacher-style hero pattern when "Enable on homepage" is on
   in theme settings → Header. */

/* -----------------------------------------------------------------------
   SEARCH OVERLAY ENHANCEMENTS
   – Escape key closes search
   – Clicking the page overlay closes search
   – Announcement bar handled via pure CSS (:has() selector in custom.css)
   ----------------------------------------------------------------------- */
(function () {
  var searchEl = document.getElementById('Search');
  if (!searchEl) return;

  var overlay = document.querySelector('.PageOverlay');

  function isSearchOpen() {
    return searchEl.getAttribute('aria-hidden') === 'false';
  }

  function closeSearch() {
    /* theme.js SearchBar uses dom-delegate on document.body (theme.js:3108).
       The event must be dispatched on body (or a child) so it bubbles up
       to the delegate root. */
    document.body.dispatchEvent(new CustomEvent('search:close', { bubbles: true }));
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isSearchOpen()) {
      closeSearch();
    }
  });

  if (overlay) {
    overlay.addEventListener('click', function () {
      if (isSearchOpen()) closeSearch();
    });
  }
})();

/* -----------------------------------------------------------------------
   DIRECTIONAL ENTRANCE OBSERVER (T14)
   Adds .hds-entrance--visible when .hds-entrance elements scroll into
   view. Threshold 0.15 = fires when 15% of the element is visible.
   Respects prefers-reduced-motion by skipping entirely — elements that
   never get the class are already visible via the CSS fallback (the
   motion query only hides them when motion is allowed).
   ----------------------------------------------------------------------- */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var targets = document.querySelectorAll('.hds-entrance');
  if (!targets.length) return;

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('hds-entrance--visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });

  targets.forEach(function (el) { observer.observe(el); });
})();

/* -----------------------------------------------------------------------
   PDP GALLERY — COUNTER + ACTIVE-THUMB SCROLL-INTO-VIEW
   Prestige's Flickity carousel toggles .is-selected on the active
   .Product__SlideItem. We observe that class change via MutationObserver
   to (1) keep the "N / total" counter in sync and (2) scroll the vertical
   thumb rail so the matching active thumb is visible. The same handler
   catches arrow clicks, thumbnail clicks, swipes, AND variant-change
   jumps (Prestige re-selects the variant's featured slide).
   ----------------------------------------------------------------------- */
(function () {
  var slideshow = document.querySelector('.Product__Slideshow');
  var counter = document.querySelector('.Product__SlideshowCounter-current');
  var thumbNav = document.querySelector('.Product__SlideshowNav--thumbnails');
  var thumbScroller = thumbNav && thumbNav.querySelector('.Product__SlideshowNavScroller');
  if (!slideshow) return;

  function findActiveIndex() {
    var slides = slideshow.querySelectorAll('.Product__SlideItem');
    for (var i = 0; i < slides.length; i++) {
      if (slides[i].classList.contains('is-selected')) return i;
    }
    return -1;
  }

  function updateCounter() {
    if (!counter) return;
    var idx = findActiveIndex();
    if (idx >= 0) counter.textContent = idx + 1;
  }

  function scrollActiveThumbIntoView() {
    if (!thumbScroller) return;
    /* DEV-534: match the thumb by photo, not by list position; the colour
       filter (DEV-506) hides and reorders thumbs, so the Nth slide is not
       the Nth thumb in the markup. */
    var activeSlide = slideshow.querySelector('.Product__SlideItem.is-selected');
    if (!activeSlide) return;
    var activeThumb = thumbScroller.querySelector('.Product__SlideshowNavImage[data-media-id="' + activeSlide.getAttribute('data-media-id') + '"]');
    if (!activeThumb) return;

    /* Dual-axis: rail is vertical at desktop (flex-direction: column) and
       horizontal at sub-desktop (flex-direction: row). Detect via computed
       style and scroll the matching axis. */
    var isHorizontal = getComputedStyle(thumbScroller).flexDirection === 'row';
    var scrollerRect = thumbScroller.getBoundingClientRect();
    var thumbRect = activeThumb.getBoundingClientRect();

    if (isHorizontal) {
      if (thumbRect.left < scrollerRect.left || thumbRect.right > scrollerRect.right) {
        var leftOffset = activeThumb.offsetLeft - (thumbScroller.clientWidth / 2) + (activeThumb.clientWidth / 2);
        thumbScroller.scrollTo({ left: leftOffset, behavior: 'smooth' });
      }
    } else {
      if (thumbRect.top < scrollerRect.top || thumbRect.bottom > scrollerRect.bottom) {
        var topOffset = activeThumb.offsetTop - (thumbScroller.clientHeight / 2) + (activeThumb.clientHeight / 2);
        thumbScroller.scrollTo({ top: topOffset, behavior: 'smooth' });
      }
    }
  }

  /* Align the featured review card's right edge to the active image's right
     edge. Slideshow cell width is fixed (flex: 1), but images letterbox
     inside it via object-fit:contain when aspect ratios differ — so the
     <img> element box is wider than the rendered pixels. Compute the true
     displayed rect from naturalWidth/naturalHeight before sizing the review.
     Review left stays at thumb-rail left. */
  function getDisplayedImageRect(img) {
    var rect = img.getBoundingClientRect();
    var natW = img.naturalWidth, natH = img.naturalHeight;
    if (!natW || !natH || !rect.width || !rect.height) return rect;
    var scale = Math.min(rect.width / natW, rect.height / natH);
    var dispW = natW * scale, dispH = natH * scale;
    var insetX = (rect.width - dispW) / 2;
    var insetY = (rect.height - dispH) / 2;
    return {
      left: rect.left + insetX,
      right: rect.left + insetX + dispW,
      top: rect.top + insetY,
      bottom: rect.top + insetY + dispH,
      width: dispW,
      height: dispH
    };
  }

  function alignReviewToImage() {
    var review = document.querySelector('.Product__Gallery .product-featured-review-desktop');
    if (!review) return;
    /* Review is hidden on desktop via CSS (matches Peacock Alley which has no
       analogous element). Skip layout work when the element is not rendered. */
    if (!review.offsetParent) return;
    var activeImg = slideshow.querySelector('.Product__SlideItem.is-selected img');
    if (!activeImg || !activeImg.getBoundingClientRect().width) return;
    if (thumbNav) {
      var imgRect = getDisplayedImageRect(activeImg);
      var thumbRect = thumbNav.getBoundingClientRect();
      var gallery = review.parentElement;
      if (!gallery) return;
      var galleryRect = gallery.getBoundingClientRect();
      review.style.width = (imgRect.right - thumbRect.left) + 'px';
      review.style.marginLeft = (thumbRect.left - galleryRect.left) + 'px';
      review.style.flex = '0 0 auto';
    }
  }

  function onSlideChange() {
    updateCounter();
    scrollActiveThumbIntoView();
    alignReviewToImage();
  }

  onSlideChange();

  var observer = new MutationObserver(onSlideChange);
  slideshow.querySelectorAll('.Product__SlideItem').forEach(function (slide) {
    observer.observe(slide, { attributes: true, attributeFilter: ['class'] });
  });

  /* Image/Flickity may finish initializing after this IIFE runs. Re-align on:
     - window.load (catches late image decode + Flickity's own load-time setup)
     - window.resize (viewport changes)
     - variant:changed (Prestige fires this when a swatch changes the gallery)
     - any newly-added slide image's load event
     Plus a deferred retry to cover the gap between init and Flickity adding
     .is-selected to the first slide. */
  window.addEventListener('load', alignReviewToImage);
  // rAF-throttled: alignReviewToImage reads getBoundingClientRect, and resize
  // fires continuously during iOS URL-bar collapse / desktop drag-resize.
  var alignResizeTicking = false;
  window.addEventListener('resize', function () {
    if (!alignResizeTicking) {
      alignResizeTicking = true;
      requestAnimationFrame(function () {
        alignResizeTicking = false;
        alignReviewToImage();
      });
    }
  });
  document.addEventListener('variant:changed', function () {
    requestAnimationFrame(alignReviewToImage);
  });
  setTimeout(alignReviewToImage, 100);
  setTimeout(alignReviewToImage, 500);
  slideshow.querySelectorAll('.Product__SlideItem img').forEach(function (img) {
    if (img.complete) return;
    img.addEventListener('load', alignReviewToImage, { once: true });
  });
})();

/* -----------------------------------------------------------------------
   PDP THUMBNAIL RAIL — UP/DOWN SCROLL ARROWS
   Wires the up/down buttons to scroll the nearest thumbnail scroller
   by ~3 thumbnails per click (Peacock Alley-style pagination cue).
   ----------------------------------------------------------------------- */
(function () {
  var arrows = document.querySelectorAll('[data-thumbnail-nav]');
  if (!arrows.length) return;

  var SCROLL_STEP = 250; // ~3 thumbs at 76px + gap

  arrows.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var nav = btn.closest('.Product__SlideshowNav--thumbnails');
      if (!nav) return;
      var scroller = nav.querySelector('.Product__SlideshowNavScroller');
      if (!scroller) return;
      var direction = btn.getAttribute('data-thumbnail-nav') === 'up' ? -1 : 1;
      scroller.scrollBy({ top: SCROLL_STEP * direction, behavior: 'smooth' });
    });
  });
})();

/* -----------------------------------------------------------------------
   PDP STICKY ADD-TO-CART BAR
   Slides down when main ATC scrolls out of view. Click delegates to the
   real .ProductForm__AddToCart so all existing form-submit behavior
   (variant validation, cart drawer, analytics) runs normally. Live price
   mirrored from .ProductMeta__PriceList on `variant:changed` (Prestige).
   ----------------------------------------------------------------------- */
(function () {
  var bar = document.querySelector('[data-pdp-sticky]');
  if (!bar) return;
  var mainAtc = document.querySelector('.ProductForm__AddToCart');
  if (!mainAtc) return;

  var stickyCta = bar.querySelector('[data-pdp-sticky-add]');
  var priceMirror = bar.querySelector('[data-pdp-sticky-price]');
  var sourcePrice = document.querySelector('.ProductMeta__PriceList');
  var qualifiedEl = bar.querySelector('[data-pdp-sticky-qualified]');
  var currentPriceCents = qualifiedEl ? parseInt(qualifiedEl.getAttribute('data-initial-price'), 10) : NaN;

  // Cache initial CTA label so we can swap to "Sold out" and back.
  if (stickyCta) stickyCta.dataset.label = stickyCta.textContent.trim();

  // IntersectionObserver: visible only when main ATC is ABOVE viewport
  // (i.e. user scrolled past it). Don't show on initial load when ATC is
  // below the fold.
  var io = new IntersectionObserver(function (entries) {
    var entry = entries[0];
    var aboveViewport = entry.boundingClientRect.top < 0;
    bar.classList.toggle('is-visible', !entry.isIntersecting && aboveViewport);
    bar.setAttribute('aria-hidden', bar.classList.contains('is-visible') ? 'false' : 'true');
  }, { threshold: 0 });
  io.observe(mainAtc);

  // Click → click main ATC. Programmatic click submits the form normally.
  if (stickyCta) {
    stickyCta.addEventListener('click', function (e) {
      e.preventDefault();
      mainAtc.click();
    });
  }

  function syncPrice() {
    if (!priceMirror || !sourcePrice) return;
    // Rebuild markup instead of copying textContent: the compare-at
    // strikethrough is drawn by theme.css .Price--compareAt::before, so a
    // plain-text copy loses the line (reported by Valerie 2026-07-02).
    var compareEl = sourcePrice.querySelector('.Price--compareAt');
    var saleEl = sourcePrice.querySelector('.Price--highlight');
    if (compareEl && saleEl) {
      priceMirror.innerHTML =
        '<span class="Price Price--compareAt">' + compareEl.textContent.trim() + '</span>' +
        '<span class="Price Price--highlight">' + saleEl.textContent.trim() + '</span>';
    } else {
      var plainEl = sourcePrice.querySelector('.Price:not(.Price--compareAt):not(.Price--highlight):not(.price-custom-savings)');
      priceMirror.textContent = (plainEl || sourcePrice).textContent.trim();
    }
  }

  function syncDisabled() {
    if (!stickyCta) return;
    var disabled = mainAtc.disabled || mainAtc.hasAttribute('disabled');
    stickyCta.disabled = disabled;
    stickyCta.textContent = disabled
      ? 'Sold out'
      : (stickyCta.dataset.label || 'Add to cart');
  }

  // Sale-qualified price (7/3 audit P1-6): during a tiered automatic-discount
  // sale the drawer shows the discounted price while the bar showed bare full
  // price — two prices in one viewport. The P2-1 qualifier snippet
  // ([data-promo-tier-qualifier]) only renders when an active tier promo
  // covers this product, and carries the tier config in data-tiers
  // ("dollars:pct,..." ascending) — its presence is the gate, and the tier
  // math stays single-source with the buy box.
  function syncQualified() {
    if (!qualifiedEl) return;
    var q = document.querySelector('[data-promo-tier-qualifier]');
    if (!q || isNaN(currentPriceCents)) { qualifiedEl.hidden = true; return; }
    var bestPct = 0;
    q.getAttribute('data-tiers').split(',').filter(Boolean).forEach(function (t) {
      var p = t.split(':');
      if (currentPriceCents >= Math.round(parseFloat(p[0]) * 100)) bestPct = parseInt(p[1], 10);
    });
    if (bestPct > 0) {
      var discounted = Math.round(currentPriceCents * (100 - bestPct) / 100);
      qualifiedEl.textContent =
        '$' + (discounted / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',') +
        ' at checkout (' + bestPct + '% off)';
      qualifiedEl.hidden = false;
    } else {
      qualifiedEl.hidden = true;
    }
  }

  // Variant selectors in the bar mirror the main form's option-N radio
  // groups. Two-way wiring: bar select change → click matching main radio
  // (which fires Prestige's variant logic), main variant:changed → update
  // bar selects to reflect new state.
  var stickyVariants = bar.querySelector('[data-pdp-sticky-variants]');
  var productForm = document.querySelector('.ProductForm');

  function syncBarFromMainForm() {
    if (!stickyVariants || !productForm) return;
    stickyVariants.querySelectorAll('select[data-sticky-option-index]').forEach(function (sel) {
      var idx = sel.getAttribute('data-sticky-option-index');
      var checked = productForm.querySelector('input[type="radio"][name="option-' + idx + '"]:checked');
      if (checked && sel.value !== checked.value) {
        sel.value = checked.value;
      }
    });
  }

  if (stickyVariants && productForm) {
    stickyVariants.querySelectorAll('select[data-sticky-option-index]').forEach(function (sel) {
      sel.addEventListener('change', function () {
        var idx = sel.getAttribute('data-sticky-option-index');
        var value = sel.value;
        // CSS.escape handles values with quotes / special chars in the
        // attribute selector. Click instead of dispatching event so
        // Prestige's full variant-change pipeline runs.
        var radio = productForm.querySelector(
          'input[type="radio"][name="option-' + idx + '"][value="' + (window.CSS && CSS.escape ? CSS.escape(value) : value.replace(/"/g, '\\"')) + '"]'
        );
        if (radio && !radio.checked) {
          radio.click();
        }
      });
    });
  }

  document.addEventListener('variant:changed', function (e) {
    if (e.detail && e.detail.variant && typeof e.detail.variant.price === 'number') {
      currentPriceCents = e.detail.variant.price;
    }
    requestAnimationFrame(function () {
      syncPrice();
      syncDisabled();
      syncBarFromMainForm();
      syncQualified();
    });
  });

  // DEV-500: the chosen options in one line ("Queen · Saffron") for the
  // bottom bar on phones and tablets, where the selects are hidden. Tapping
  // it scrolls back to the option buttons. Also mark the body while the bar
  // shows so the chat bubble can step above it (front-chat-launcher.liquid).
  var summaryText = bar.querySelector('[data-pdp-sticky-summary-text]');
  var summaryBtn = bar.querySelector('[data-pdp-sticky-summary]');
  function syncSummary(variant) {
    if (!summaryText || !variant || !variant.title) return;
    summaryText.textContent = String(variant.title).replace(/ \/ /g, ' \u00b7 ');
  }
  if (summaryBtn) {
    summaryBtn.addEventListener('click', function () {
      var target = document.querySelector('.Product__Info .ProductForm__Variants') || document.querySelector('.Product__Info');
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }
  function syncBarState() {
    var visible = bar.classList.contains('is-visible');
    document.body.classList.toggle('pdp-sticky-visible', visible);
    if (visible) {
      document.documentElement.style.setProperty('--pdp-sticky-h', bar.getBoundingClientRect().height + 'px');
    }
  }
  new MutationObserver(syncBarState).observe(bar, { attributes: true, attributeFilter: ['class'] });
  document.addEventListener('variant:changed', function (e) {
    if (e.detail && e.detail.variant) syncSummary(e.detail.variant);
  });

  syncPrice();
  syncDisabled();
  syncBarFromMainForm();
  syncQualified();
  syncBarState();
})();

/* -----------------------------------------------------------------------
   DESKTOP SMART HEADER (DEV-264)
   Keeps the complete two-row header visible at the top and during upward
   travel, then releases its viewport space during deliberate downward
   travel. Open header UI and keyboard focus always force the header visible.
   CSS coordinates the PDP sticky ATC so only one top-edge system is visible.
   ----------------------------------------------------------------------- */
(function () {
  var desktop = window.matchMedia('(min-width: 1140px)');
  var announcement = document.getElementById('shopify-section-announcement');
  var headerSection = document.getElementById('shopify-section-header');
  var header = headerSection && headerSection.querySelector('.Header');

  if (!announcement || !headerSection || !header) return;

  var TOP_ZONE = 10;
  var HIDE_AFTER = 120;
  var HIDE_TRAVEL = 24;
  var REVEAL_TRAVEL = 18;
  var lastY = Math.max(0, window.scrollY || window.pageYOffset || 0);
  var travel = 0;
  var direction = 0;
  var ticking = false;

  function searchIsOpen() {
    var search = document.getElementById('Search');
    return search && search.getAttribute('aria-hidden') === 'false';
  }

  function headerUiIsOpen() {
    return searchIsOpen() || !!header.querySelector(
      '.HorizontalList__Item.is-expanded, ' +
      '.MegaMenu[aria-hidden="false"], ' +
      '.PaseoPanel[aria-hidden="false"]'
    );
  }

  function showHeader() {
    var y = Math.max(0, window.scrollY || window.pageYOffset || 0);

    /* The utility and navigation rows are separate Shopify sections. Settle
       their shared opaque state before either section re-enters the viewport
       so the announcement layer cannot paint one transparent frame first. */
    if (headerUiIsOpen() || y > TOP_ZONE) {
      if (header.classList.contains('Header--transparent')) {
        header.classList.remove('Header--transparent');
      }
      if (document.body.classList.contains('announcement-bar--transparent')) {
        document.body.classList.remove('announcement-bar--transparent');
      }
    }

    if (document.body.classList.contains('hea-smart-header--hidden')) {
      setHidden(false);
    }
  }

  function hideHeader() {
    if (!headerUiIsOpen() && !document.body.classList.contains('hea-smart-header--hidden')) {
      setHidden(true);
    }
  }

  /* DEV-521: bars pinned under the header (collection Filter / Sort, gift
     guide shop-by) change their sticky offset with the header class. Easing
     that offset ran on the main thread and trailed the header's transform,
     flashing a gap on the way down and hiding the bar on the way up. Each
     bar now jumps to its new offset and a transform, started in the same
     frame as the header's, carries it there on the header's easing. */
  var FOLLOWERS = '.CollectionMain .CollectionToolbar--top, .hgg-nav';
  var FOLLOW_TRANSITION = 'transform 0.38s cubic-bezier(0.645, 0.045, 0.355, 1)';

  function setHidden(hidden) {
    var bars = Array.prototype.slice.call(document.querySelectorAll(FOLLOWERS));
    var before = bars.map(function (bar) { return bar.getBoundingClientRect().top; });

    document.body.classList.toggle('hea-smart-header--hidden', hidden);

    bars.forEach(function (bar, i) {
      bar.style.transition = 'none';
      bar.style.transform = 'none';
      var delta = before[i] - bar.getBoundingClientRect().top;

      if (Math.abs(delta) < 1) {
        bar.style.transition = '';
        bar.style.transform = '';
        return;
      }

      bar.style.transform = 'translateY(' + delta + 'px)';
      bar.getBoundingClientRect();
      bar.style.transition = FOLLOW_TRANSITION;
      bar.style.transform = '';
    });
  }

  function resetTravel(y) {
    lastY = y;
    travel = 0;
    direction = 0;
  }

  function update() {
    ticking = false;
    var y = Math.max(0, window.scrollY || window.pageYOffset || 0);

    if (!desktop.matches) {
      showHeader();
      resetTravel(y);
      return;
    }

    if (headerUiIsOpen() || y <= TOP_ZONE) {
      showHeader();
      resetTravel(y);
      return;
    }

    var delta = y - lastY;
    lastY = y;
    if (Math.abs(delta) < 1) return;

    var nextDirection = delta > 0 ? 1 : -1;
    if (nextDirection !== direction) {
      direction = nextDirection;
      travel = 0;
    }
    travel += Math.abs(delta);

    if (direction > 0 && y > HIDE_AFTER && travel >= HIDE_TRAVEL) {
      hideHeader();
      travel = 0;
    } else if (direction < 0 && travel >= REVEAL_TRAVEL) {
      showHeader();
      travel = 0;
    }
  }

  function requestUpdate() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(update);
  }

  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate);

  /* Search, mega menus and the Paseo panel mutate aria/class state after
     their initiating event. Observe those changes so a hidden header is
     restored before an open surface can be stranded offscreen. */
  var stateObserver = new MutationObserver(function () {
    /* The observer also sees the header class that showHeader() can change.
       Only wake a header that is actually hidden so an already-visible menu
       mutation cannot recursively schedule this callback. */
    if (document.body.classList.contains('hea-smart-header--hidden') && headerUiIsOpen()) {
      showHeader();
    }
  });
  stateObserver.observe(header, {
    subtree: true,
    attributes: true,
    attributeFilter: ['aria-hidden', 'class']
  });
  var search = document.getElementById('Search');
  if (search) {
    stateObserver.observe(search, {
      attributes: true,
      attributeFilter: ['aria-hidden', 'class']
    });
  }

  document.addEventListener('focusin', function (event) {
    if (headerSection.contains(event.target) || announcement.contains(event.target)) {
      showHeader();
    }
  });

  if (desktop.addEventListener) {
    desktop.addEventListener('change', requestUpdate);
  } else {
    desktop.addListener(requestUpdate);
  }

  requestUpdate();
})();

/* -----------------------------------------------------------------------
   DEV-506 (2026-10-16): PRODUCT GALLERY FILTERED BY COLOUR
   When at least one photo carries a colour name in its alt text (the
   section marks data-color-tagged > 0), the gallery shows only the chosen
   colour's photos plus colour-neutral ones. With no tagged photos nothing
   here runs and the gallery is exactly as before. Slides are removed from
   and re-added to the Flickity carousel so swiping, the counter and the
   thumbnail strip all agree; when Flickity is inactive (stacked layout) the
   slides are simply hidden.
   ----------------------------------------------------------------------- */
(function () {
  var gallery = document.querySelector('.Product__Gallery[data-color-option-index]');
  if (!gallery) return;
  if (!(parseInt(gallery.getAttribute('data-color-tagged'), 10) > 0)) return;
  var optIdx = parseInt(gallery.getAttribute('data-color-option-index'), 10);
  if (isNaN(optIdx)) return;
  var slideshowEl = gallery.querySelector('.Product__Slideshow');
  if (!slideshowEl) return;
  var allSlides = Array.prototype.slice.call(slideshowEl.querySelectorAll('.Product__SlideItem'));
  var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('.Product__SlideshowNavImage'));
  var counterTotal = gallery.querySelector('.Product__SlideshowCounter-total');
  var dotsWrap = gallery.querySelector('.flickity-page-dots');
  var currentKey = null;

  function handleize(v) {
    return String(v || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }
  function keeps(el, key) {
    var k = el.getAttribute('data-color-key');
    return !k || k === key;
  }
  function flickity() {
    return window.Flickity && typeof Flickity.data === 'function' ? Flickity.data(slideshowEl) : null;
  }

  function apply(key, featuredMediaId) {
    if (key === currentKey && !featuredMediaId) return;
    currentKey = key;
    // the chosen colour's own photos first, then the colour-neutral ones, each in catalogue order
    var own = allSlides.filter(function (s) { return s.getAttribute('data-color-key') === key; });
    var neutral = allSlides.filter(function (s) { return !s.getAttribute('data-color-key'); });
    var wanted = own.concat(neutral);
    if (!wanted.length) wanted = allSlides;
    var flkty = flickity();
    if (flkty && flkty.isActive) {
      var present = allSlides.filter(function (s) { return s.parentNode; });
      var toRemove = present.filter(function (s) { return wanted.indexOf(s) < 0; });
      if (toRemove.length) flkty.remove(toRemove);
      // rebuild in the wanted order (own colour first): drop what stays, then append the full list
      var stay = wanted.filter(function (s) { return s.parentNode; });
      var inOrder = stay.length === wanted.length && stay.every(function (s, i) { return flkty.cells[i] && flkty.cells[i].element === s; });
      if (!inOrder) {
        if (stay.length) flkty.remove(stay);
        flkty.append(wanted);
      }
      flkty.resize();
      var idx = 0;
      if (featuredMediaId) {
        for (var i = 0; i < flkty.cells.length; i++) {
          if (flkty.cells[i].element.getAttribute('data-media-id') === String(featuredMediaId)) { idx = i; break; }
        }
      }
      flkty.select(idx, false, true);
      // DEV-534: Prestige only re-lights the thumbnail when the index changes, and after the
      // rebuild index 0 can be a different photo, so light the thumb for the photo now showing
      var shownId = flkty.selectedElement && flkty.selectedElement.getAttribute('data-media-id');
      thumbs.forEach(function (t) { t.classList.toggle('is-selected', t.getAttribute('data-media-id') === shownId); });
    } else {
      allSlides.forEach(function (s) { s.classList.toggle('is-color-hidden', wanted.indexOf(s) < 0); });
    }
    thumbs.forEach(function (t) { t.classList.toggle('is-color-hidden', !keeps(t, key)); });
    // thumbnail strip follows the same order: own colour first
    var strip = thumbs.length && thumbs[0].parentNode;
    if (strip) {
      thumbs.forEach(function (t) { t.style.order = ''; });
      var n = 0;
      thumbs.filter(function (t) { return t.getAttribute('data-color-key') === key; }).forEach(function (t) { t.style.order = String(-1000 + n++); });
    }
    if (counterTotal) counterTotal.textContent = wanted.length;
    if (dotsWrap) {
      dotsWrap.innerHTML = '';
      wanted.forEach(function (_, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'dot' + (i === 0 ? ' is-selected' : '');
        b.setAttribute('data-index', i);
        b.setAttribute('aria-label', 'Go to image ' + (i + 1));
        dotsWrap.appendChild(b);
      });
    }
  }

  document.addEventListener('variant:changed', function (e) {
    var v = e.detail && e.detail.variant;
    if (!v || !v.options) return;
    var key = handleize(v.options[optIdx]);
    var fm = v.featured_media && v.featured_media.id;
    // after Prestige's own handler (which selects the featured photo by carousel index since DEV-534)
    setTimeout(function () { apply(key, fm); }, 0);
  });

  // first run once the carousel exists (Prestige builds it on section load)
  var initialKey = gallery.getAttribute('data-color-initial') || '';
  var tries = 0;
  (function waitForCarousel() {
    var f = flickity();
    if (f || tries > 40) { apply(initialKey, null); return; }
    tries++;
    setTimeout(waitForCarousel, 50);
  })();
})();

/* DEV-519 (2026-10-16): a sold-out size no longer makes the buy box jump.
   The sold-out block (.oos-label-container, a separate product block placed above the size
   picker) moves into the Add to Cart slot, so its Notify button takes the button's place.
   Its status line ("Sold out" plus the restock wording theme.js writes) shows in the
   delivery row's place inside the buy-box answers, which hides "Ships today" for sold-out
   sizes. The price block keeps the tallest height it has shown, so the Afterpay line
   leaving for a sold-out size does not pull the page up. theme.js and the inline script in
   main-product.liquid still decide sold out or not; this only follows them. */
(function () {
  var form = document.querySelector('.Product__Info .ProductForm');
  if (!form) return;
  var oos = form.querySelector('.oos-label-container');
  var buy = form.querySelector('.ProductForm__BuyButtons');
  var cta = document.getElementById('oos_notifyme_cta');
  if (!oos || !buy || !cta) return;

  buy.parentNode.insertBefore(oos, buy);
  oos.classList.add('oos-in-slot');

  var status = oos.querySelector('.oos-status');
  var labelText = oos.querySelector('.oos-label-text');
  var etaEl = oos.querySelector('#eta-date');

  var bba = form.closest('.Product__Info').querySelector('[data-buy-box-answers]');
  var shipLine = bba && bba.querySelector('[data-bba-ship]');
  var line = null, lineStrong = null, lineRest = null;
  if (shipLine) {
    line = document.createElement('div');
    line.className = 'bba__line bba__oos';
    line.hidden = true;
    line.innerHTML = '<svg class="bba__icon" aria-hidden="true" focusable="false" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="5" width="18" height="16" rx="1"/><path d="M3 10h18M8 3v4M16 3v4"/></svg>'
      + '<div class="bba__text"><p class="bba__copy"><span class="bba__strong"></span><span class="bba__oos-rest"></span></p></div>';
    shipLine.parentNode.insertBefore(line, shipLine.nextSibling);
    lineStrong = line.querySelector('.bba__strong');
    lineRest = line.querySelector('.bba__oos-rest');
  }

  var meta = form.querySelector('.ProductMeta');
  var metaMax = 0;

  function selectedSize() {
    // every chosen option except colour (the swatches already show it): "Twin XL", "Comforter Set / Twin XL"
    var names = [];
    form.querySelectorAll('.ProductForm__Option').forEach(function (o) {
      var label = o.querySelector('.ProductForm__Label, legend, label');
      if (label && /^\s*colou?r/i.test(label.textContent)) return;
      var input = o.querySelector('input[type=radio]:checked');
      if (input) names.push(input.value);
    });
    return names.join(' / ');
  }

  function sync() {
    var soldOut = getComputedStyle(oos).display !== 'none';
    var comingSoon = status && /coming/i.test(status.textContent);
    // Write only on change: the button sits inside the observed container, so
    // an unconditional write re-triggered sync every frame (DEV-532).
    var ctaText = comingSoon ? 'Notify me when it’s available' : 'Notify me when it’s back';
    if (cta.textContent !== ctaText) cta.textContent = ctaText;
    if (line) {
      line.hidden = !soldOut;
      if (soldOut) {
        var size = selectedSize();
        lineStrong.textContent = (comingSoon ? 'Coming soon' : 'Sold out') + (size ? ' in ' + size : '');
        var eta = etaEl ? etaEl.textContent.trim() : '';
        var lead = labelText ? labelText.textContent.trim() : '';
        var rest = eta ? (lead ? lead + ' ' : '') + eta.replace(/^on\s+/i, comingSoon ? '' : 'on ')
                       : (comingSoon ? 'Release date to come' : 'Restock date to come');
        lineRest.textContent = rest;
      }
    }
    if (meta) {
      meta.style.minHeight = '';
      var h = meta.getBoundingClientRect().height;
      if (h > metaMax) metaMax = h;
      if (metaMax) meta.style.minHeight = metaMax + 'px';
    }
  }

  new MutationObserver(function () { window.requestAnimationFrame(sync); })
    .observe(oos, { attributes: true, attributeFilter: ['style', 'class'], childList: true, subtree: true, characterData: true });
  if (meta) {
    new MutationObserver(function () { window.requestAnimationFrame(sync); }).observe(meta, { childList: true, subtree: true });
  }
  document.addEventListener('variant:changed', function () { window.requestAnimationFrame(sync); });
  sync();
  setTimeout(sync, 1500);
})();
